$card-height: 5.5rem;
$card-gap: 1rem;
$visible-items: 5;

.container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.feed {
  position: relative;
  width: min(100%, 27rem);
  height: $card-height * $visible-items + $card-gap * ($visible-items - 1);
  flex-shrink: 0;
}

// Fills the container's height, anchored to its bottom; cards above its top edge are clipped
// behind a fade over the top part so they disappear before reaching the edge.
.fill {
  align-items: stretch;
  mask-image: linear-gradient(transparent, #000 45%);

  .feed {
    height: 100%;
  }
}

.card {
  position: absolute;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  display: flex;
  height: $card-height;
  flex-direction: row;
  align-items: center;
  gap: 0.875rem;
  overflow: hidden;
  padding: 0 1rem;
  opacity: max(0.6, calc(1 - var(--slot) * 0.1));
  transform: translateY(calc(var(--slot) * -1 * (#{$card-height} + #{$card-gap})));
  transition:
    transform 600ms var(--ease-strong-in-out),
    opacity 600ms var(--ease-strong-in-out),
    border-color 300ms ease;
}

.cardLeaving {
  opacity: 0;
}

.cardEntering {
  animation: cardEnter 500ms 200ms var(--ease-strong-out) both;
}

.cardScanning {
  border-color: var(--color-primary-border);
}

.typeIcon {
  display: grid;
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
  place-items: center;
  border-radius: var(--radius-md, 0.5rem);
  background: var(--color-surface-raised);
  color: var(--color-muted-foreground);
}

.body {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 0.625rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scores {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
}

.score {
  flex-shrink: 0;
  color: var(--color-foreground);

  :global(.calmlens-progress-circle-content) svg {
    width: 0.875rem;
    height: 0.875rem;
  }

  :global(.calmlens-progress-circle-value) {
    transition: stroke-dashoffset 700ms var(--ease-strong-out);
  }

  @for $i from 2 through 6 {
    &:nth-child(#{$i}) :global(.calmlens-progress-circle-value) {
      transition-delay: ($i - 1) * 40ms;
    }
  }
}

// A ring stretched into a pill around the flagged category's icon and name; its outline fills
// with the score like the rings beside it.
.status {
  flex-shrink: 0;
}

.scanLine {
  position: absolute;
  top: 0;
  bottom: 0;
  // Physical: the sweep runs left to right in either direction, like the gradient it carries.
  left: 0;
  width: 35%;
  background: linear-gradient(
    90deg,
    transparent,
    color-mix(in srgb, var(--color-primary) 18%, transparent) 70%,
    color-mix(in srgb, var(--color-primary) 60%, transparent) 99%,
    transparent
  );
  opacity: 0;
  translate: -100% 0;
  pointer-events: none;
}

.cardScanning .scanLine {
  animation: scan 1100ms 300ms linear both;
}

@keyframes cardEnter {
  from {
    opacity: 0;
    translate: 0 50%;
  }
}

@keyframes scan {
  0% {
    opacity: 1;
    translate: -100% 0;
  }

  85% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    translate: 290% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    transition:
      opacity 300ms ease,
      border-color 300ms ease;
  }

  .cardLeaving {
    opacity: 0;
  }

  .cardEntering {
    animation-name: fadeIn;
  }

  .cardScanning .scanLine {
    animation: none;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
}
